// services/authService.js
import API_ENDPOINTS from '../config/apiEndpoints';
import apiClient from './apiClient';

class AuthService {

    async register(userData) {
        console.log(`authService: Attempting to register user. URL: ${API_ENDPOINTS.AUTH.REGISTER}`);
        try {
            const response = await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, userData);
            console.log("authService: Registration API call successful.", response.data);
            return { success: true, data: response.data };
        } catch (error) {
            console.error('authService: Registration failed.', error);
            if (error.isAxiosError && error.response) {
                throw error.response.data;
            }
            throw new Error('An unexpected error occurred during registration.');
        }
    }

    async login(email, password) {
        console.log(`authService: Attempting login for email: ${email}. URL: ${API_ENDPOINTS.AUTH.LOGIN}`);
        try {
            const response = await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, {
                email,
                password
            });

            console.log("authService: Login API call successful. Full Axios response object:", response);
            console.log("authService: Response data from backend:", response.data);

            // Vérifier que nous avons reçu les tokens et les données utilisateur
            if (response && response.data && response.data.user && response.data.access) {
                console.log("authService: Login successful. Storing tokens and user data.");
                
                // Stocker les tokens dans localStorage
                localStorage.setItem('access_token', response.data.access);
                if (response.data.refresh) {
                    localStorage.setItem('refresh_token', response.data.refresh);
                }
                
                // Stocker les informations utilisateur
                localStorage.setItem('user', JSON.stringify(response.data.user));
                
                return { success: true, user: response.data.user };
            } else {
                console.error("authService: Invalid response structure, missing tokens or user data.", response.data);
                throw new Error("Réponse invalide du serveur: données utilisateur ou tokens manquants.");
            }
        } catch (error) {
            console.error('authService: Login API call or processing failed.',
                'Error message:', error.message,
                'Error name:', error.name,
                'Is Axios Error:', error.isAxiosError);

            if (error.isAxiosError) {
                if (error.response) {
                    console.error("authService: Axios error with response. Status:", error.response.status, "Data:", error.response.data);

                    let errorMessage = null;
                    if (error.response.data?.detail) {
                        errorMessage = error.response.data.detail;
                    }
                    else if (error.response.data?.non_field_errors && Array.isArray(error.response.data.non_field_errors) && error.response.data.non_field_errors.length > 0) {
                        errorMessage = error.response.data.non_field_errors[0];
                    }
                    else {
                        errorMessage = `Échec de la requête avec le statut ${error.response.status}`;
                    }

                    console.log("authService: Extracted error message:", errorMessage);
                    throw new Error(errorMessage);
                } else if (error.request) {
                    console.error("authService: Axios error - no response received:", error.request);
                    throw new Error('Aucune réponse reçue du serveur. Vérifiez votre connexion réseau et si le serveur backend est en cours d\'exécution.');
                } else {
                    console.error('authService: Axios error - error setting up request:', error.message);
                    throw new Error(`Erreur lors de la préparation de la requête: ${error.message}`);
                }
            } else {
                console.error('authService: Non-Axios error during login:', error);
                throw error;
            }
        }
    }

    async logout() {
        console.log("authService: logout called. Clearing tokens and calling backend logout.");
        
        const refreshToken = localStorage.getItem('refresh_token');
        
        // Clear tokens first to prevent infinite loops
        this.clearTokens();
        
        // Try to logout on backend only if we have a refresh token
        if (refreshToken) {
            try {
                await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT, {
                    refresh: refreshToken
                });
                console.log("authService: Backend logout successful.");
            } catch (error) {
                console.error('authService: Backend logout failed.', error);
                // Continue with client-side logout even if backend fails
            }
        } else {
            console.log("authService: No refresh token found, skipping backend logout.");
        }
    }

    clearTokens() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
    }

    getAccessToken() {
        return localStorage.getItem('access_token');
    }

    getRefreshToken() {
        return localStorage.getItem('refresh_token');
    }

    getCurrentUser() {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    }

    isAuthenticated() {
        const token = this.getAccessToken();
        const user = this.getCurrentUser();
        return !!(token && user);
    }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
